<template>
  <div class="my_container">
    <div>
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>用户指引</span>
        </p>
        <el-divider></el-divider>
      </div>
      <div class="user_guide_box">
        <el-tabs :tab-position="tabPosition">
          <el-tab-pane>
            <p slot="label"><i></i> 如何开播</p>
            <div class="begin_show_box">
              <p class="begin_show_text">1. 在平台的右下角侧边栏选择“<i>开始直播</i>”，进入直播申请界面</p>
              <p><img src="../../assets/img/userGuide/beginShowStep1-1.png" alt=""></p>
              <p class="begin_show_text">2. 在直播申请界面输入对应的信息后点击<i>"提交"</i></p>
              <p><img src="../../assets/img/userGuide/beginShowStep2-1.png" alt=""></p>
              <p class="begin_show_text">3.提交成功后，请耐心等待审核通过</p>
              <p><img src="../../assets/img/userGuide/beginShowStep3-1.png" alt=""></p>
              <p class="begin_show_text">4.审核通过后，在临近直播时间的30分钟以内，点击“<i>我要开播</i>”按钮，获取系统分配给您对应的推流地址。</p>
              <p><img src="../../assets/img/userGuide/beginShowStep4-1.png" alt=""></p>
              <p><img src="../../assets/img/userGuide/beginShowStep4-2.png" alt=""></p>
              <p class="begin_show_text">5.打开OBS，点击“<i>设置 -> 推流 -> 输入获取的服务器与串流密钥 -> 确定 -> 开始推流</i>” 即可开始直播</p>
              <p class="begin_show_text">OBS官方网站下载地址：<a href="https://obsproject.com/zh-cn/download" target="_blank"><i>https://obsproject.com/zh-cn/download</i></a></p>
              <p><img src="../../assets/img/userGuide/beginShowStep5-1.png" alt=""></p>
              <p class="begin_show_text">6.直播结束后，<br>
              在OBS软件上点击“<i>停止推流</i>”按钮，<br>
              在绿盟社交平台“<i>个人中心 -> 发布管理 -> 直播列表 -> 关闭直播</i>”，即可下播</p>
              <p><img src="../../assets/img/userGuide/beginShowStep6-1.png" alt=""></p>
              <p class="begin_show_text">附：OBS官方网站下载地址：<a href="https://obsproject.com/zh-cn/download" target="_blank"><i>https://obsproject.com/zh-cn/download</i></a></p>
              <p class="begin_show_text">附：OBS操作教程：<a href="https://jingyan.baidu.com/article/9f63fb915a960ec8400f0efd.html" target="_blank"><i>https://jingyan.baidu.com/article/9f63fb915a960ec8400f0efd.html</i></a></p>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tabPosition: 'left'
    }
  }
}
</script>

<style scoped="scoped">
  .user_guide_box{
    margin-bottom: 30px;
  }
  img{
    width: 500px;
    height: auto;
  }
  .begin_show_box p.begin_show_text{
    font-size: 14px;
    line-height: 50px;
  }
</style>
